import { DetailBar, Space, Text, Title } from "components/common"
import { t } from "i18next"
import styles from "./index.module.less"
import { joinBytItems, localisedValue } from "utils"
import DateTime from "utils/dateTime"
import { IconText, Separator } from "components/custom"
import { useMemo } from "react"
import { dateTimeFunction, getElapsedTime } from "utils/date"
import { classifications as leadClassifications } from "features/shared/data"

const ClientDetailBar = ({ leadDetailInfo, client, lead, project }) => {
  const getDueTime = date => {
    const currentTime = DateTime.getStartOfDay(DateTime.currentTime())
    const deadline = DateTime.getStartOfDay(date)

    if (DateTime.isSameDay(currentTime, deadline)) {
      return t("Due Today")
    }

    if (DateTime.isAfterCurrentDay(deadline)) {
      const daysAfter = DateTime.getNumberOfDaysBetweenDates(currentTime, deadline)

      if (daysAfter === 1) return t("Due Tomorrow")

      return t("Due in ") + daysAfter + " " + t("days")
    } else {
      const daysBefore = DateTime.getNumberOfDaysBetweenDates(deadline, currentTime)
      return daysBefore + t(" days Overdue")
    }
  }

  const lastTaskComments = useMemo(
    () => [
      {
        label: t("Task Comments"),
        data: localisedValue({ object: leadDetailInfo?.lastTask, key: "description" }),
      },
    ],
    [leadDetailInfo]
  )

  const getClientDetail = useMemo(
    () => [
      {
        label: t("Client"),
        value: (
          <Space>
            <IconText
              icon="MdLocalFireDepartment"
              message={leadClassifications()[lead?.InternalInquiryClassification?.id]?.name}
              iconProps={{
                color: leadClassifications()[lead?.InternalInquiryClassification?.id]?.style.color,
                hasBackground: true,
              }}
              title={
                localisedValue({ object: lead, key: "clientName" }) || localisedValue({ object: client, key: "name" })
              }
            />
            <Separator />
            <Text type="info">{lead?.id || lead?.inquiryIds}</Text>
          </Space>
        ),
      },
      {
        label: t("Interested Project"),
        value: (
          <Text type="info">
            {localisedValue({ object: project, key: "name" })
              ? localisedValue({ object: project, key: "name" })
              : project
              ? project
              : localisedValue({ object: lead?.Project, key: "name" })}
          </Text>
        ),
      },
      ...(leadDetailInfo?.tasks?.length
        ? [
            {
              label: t("Last Task"),
              value: joinBytItems(
                [
                  localisedValue({ key: "name", object: leadDetailInfo?.lastTask }),
                  <Text type="secondary">{getElapsedTime(leadDetailInfo?.lastTask?.deadline)}</Text>,
                ],
                <Separator />
              ),
            },
            {
              label: t("Planned Next Task"),
              value: leadDetailInfo?.nextTask?.nextStatusDeadline
                ? joinBytItems(
                    [
                      localisedValue({ key: "nextStatusTitle", object: leadDetailInfo?.nextTask }),
                      <Text type="secondary">
                        {getDueTime(
                          dateTimeFunction({ date: leadDetailInfo?.nextTask?.nextStatusDeadline, Default: true })
                        )}
                      </Text>,
                    ],
                    <Separator />
                  )
                : localisedValue({ key: "nextStatusTitle", object: leadDetailInfo?.nextTask }),
            },
          ]
        : []),
    ],
    [lead, project, client, leadDetailInfo]
  )

  return (
    <div>
      <Title type="secondary" level={4}>
        {t("Client Details")}
      </Title>
      <DetailBar
        detailData={getClientDetail}
        collapsible={!!leadDetailInfo?.lastTask?.description}
        expandIconTitle={t("Last Task Comments")}
        listData={lastTaskComments}
        className={styles.addTaskGrid}
      />
    </div>
  )
}
export default ClientDetailBar
